<template>
  <div class="modal-mask" @mousedown.self.stop="closeModal">
    <div class="modal" @click.stop :style="{height:`${height}`, maxWidth:`${maxWidth}`}">
      <div class="modal__head">
        <h3 class="modal__title">{{title}}</h3>
        <div class="close" @click.stop="closeModal">
          <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 1L16 16" stroke="currentColor" stroke-width="2"/>
            <path d="M1 16L16 1" stroke="currentColor" stroke-width="2"/>
          </svg>
        </div>
      </div>
      <div class="modal__body custom-scrollbar">
        <div class="flex flex-column mb-20">
          <slot name="workersModalBody"></slot>
        </div>
      </div>
      <div class="modal__footer">
        <slot name="workersModalFooter"></slot>
      </div>
    </div>
  </div>

</template>

<script>

export default {
  name: 'LogisticTransportUpdateFuelModal',
  components: {
  },
  props: {
    title: {
      type: String,
      default: 'Редактировать'
    },
    height: {
      type: String,
      default: '90vh'
    },
    maxWidth: {
      type: String,
      default: '990px'
    }
  },
  methods: {
    closeModal () {
      this.$emit('close-modal')
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/system/_vars';
@import '../../assets/css/system/_mixins';

.modal {
  max-width: 990px;
  width: 100%;
  position: relative;

  .preloader-page-mask {
    position: absolute;
    padding-left: 0;
  }

  &__text {
    text-align: center;
    color: $font_color_second;
    margin-bottom: 20px;
  }

  &__button-wrap {
    display: flex;
    flex-flow: row wrap;
    justify-content: center;
  }

  &__body {
    width: 100%;
    height: 100%;
    overflow-y: auto;
    padding-bottom: 0;
  }

  &__footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    padding: 20px 40px
  }

  &__button {
    margin-right: 16px;

    &:last-child {
      margin-right: 0;
    }
  }
}
</style>

}
